import React, { useCallback, useEffect } from 'react';
import { Button, message } from 'antd';
import * as CONSTANT from '../../constant';
import styles from './index.less';
import getActualShareLink from './getActualShareLink';
import CustomerContext from '../CustomerContext';
import copy from 'copy-to-clipboard';

const LinkPane = ({ url, hide, cid: propCid }) => {
  let cid = React.useContext(CustomerContext);
  if (propCid) {
    cid = propCid;
  }
  const finalUrl = getActualShareLink(url, cid);

  const copyUrl = useCallback(() => {
    if (copy(finalUrl, { format: 'text/plain' })) {
      message.info('Copied to clipboard');
    }
  }, [finalUrl]);

  useEffect(() => {
    copyUrl();
  }, [copyUrl]);

  const handleOnCopy = () => {
    copyUrl();
    hide();
  };

  return (
    <div>
      <div className={styles.row}>
        <a target="_blank" rel="noopener noreferrer" href={finalUrl}>
          {finalUrl}
        </a>
      </div>
      <div className={styles.row}>
        <Button type="primary" onClick={handleOnCopy}>
          {CONSTANT.CLIPBOARD}
        </Button>
      </div>
    </div>
  );
};

export default LinkPane;
